'use client';

import { useEffect } from 'react';
import { EXTERNAL_SCRIPTS, isSafeEmbedUrl } from '../providers';
import { useExternalScript } from '../useExternalScript';

interface InstagramEmbedProps {
  url?: string;
  src?: string;
  title?: string;
}

declare global {
  interface Window {
    instgrm?: {
      Embeds?: {
        process: () => void;
      };
    };
  }
}

export function InstagramEmbed({ url, src, title }: InstagramEmbedProps) {
  const permalink = url ?? src;
  const status = useExternalScript(
    isSafeEmbedUrl(permalink) ? EXTERNAL_SCRIPTS.instagram : undefined,
  );

  useEffect(() => {
    if (status === 'ready') {
      window.instgrm?.Embeds?.process();
    }
  }, [status, permalink]);

  if (!isSafeEmbedUrl(permalink)) return null;

  return (
    <div className='my-lg flex justify-center' aria-label={title || undefined}>
      <blockquote
        className='instagram-media'
        data-instgrm-permalink={permalink}
        data-instgrm-version='14'
      />
    </div>
  );
}
